import * as Yup from 'yup'

export default Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório!'),
    requestsQty: Yup.number().typeError('Insira uma quantidade válida!').integer('Insira uma quantidade válida!').positive('Insira uma quantidade válida!').required('Quantidade de Consultas é obrigatório!'),
    monthlyCost: Yup.number().positive('Insira um valor válido!').required('Valor Mensal é obrigatório!'),
    costPerSurplus: Yup.number().positive('Insira um valor válido!').required('Custo por Excedente é obrigatório!')
})